export const FILE_ACTION_PREFIX = '[File State] ';

export class LoadDocumentsAction {
    static readonly type = `${FILE_ACTION_PREFIX} Load Documents`;
    constructor(public jobRefId: string) { }
}

export class LoadDocumentsOfJpm {
  static readonly type = `${FILE_ACTION_PREFIX} Load Documents for the JPM`;
  constructor(public jpmId: string) {}
}

export class LoadFileURLAction {
    static readonly type = `${FILE_ACTION_PREFIX} Load File Url`;
    constructor(public key: string) {}
}

export class LoadJPMDocumentsAction {
  static readonly type = `${FILE_ACTION_PREFIX} Load JPM Documents`;
  constructor(public orgId: string, public jobRefId: string) { }
}

export class LoadCustomerAndSupplierContractsAction {
  static readonly type = `${FILE_ACTION_PREFIX} Load Customer And Supplier Contracts`;
  constructor(public orgId: string, public jobRefId: string, public loadId: string) {}
}

export class LoadLogSheetsForLoadAction {
  static readonly type = `${FILE_ACTION_PREFIX} Load Log Sheets For Load`;
  constructor(public orgId: string, public jobRefId: string, public loadId: string) {}
}

/** Loads the log sheet versions of several loads at once (to know which loads have a log sheet). */
export class LoadLogSheetsForLoadsAction {
  static readonly type = `${FILE_ACTION_PREFIX} Load Log Sheets For Loads`;
  constructor(public orgId: string, public jobRefId: string, public loadIds: string[]) {}
}
